import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import {StyleSheet, Image, Platform} from 'react-native';
import TabNavi from '../classes/navigation';

const Tab = createBottomTabNavigator();


const TabNavigator = React.memo(props => {
  const navStyle = props.route.params.navConfig.styles;
  const topNavStyle = props.route.params.topBarNavStyles;
  const hideThis =  props.route.params.hideSections;
  const endFlowURLS = props.route.params.endFlowURLS;

  const buildNavigator = () => {
    //console.log("route params:", props.route.params.navConfig.styles);
    if(props.route.params.navConfig.pages.length > 0){
      const bottomBarPages = props.route.params.navConfig.pages;
      return (
        props.route.params.navConfig.pages.map(function(item, i){
          let name = "";
          name = item.name.length >= 7 ? item.name.substring(0, 7)+"…" : item.name;
          return (
            <Tab.Screen
              key={i}
              name={name}
              options={({...props}) => ({
                tabBarVisible: true,
                headerShown: false,
                tabBarIcon: ({ focused, }) => (
                  <Image 
                    source={item.icon == null ? item.imageLocal : {uri: item.icon}} 
                    style={{
                      width: 25, 
                      height: 25, 
                      resizeMode: "contain", 
                      tintColor:(focused ? 
                        navStyle.activeIconColor : 
                        navStyle.defaultIconColor
                      )
                    }} 
                    tintColor={focused ?
                      navStyle.activeIconColor : 
                      navStyle.defaultIconColor
                    } 
                  />
                ),
              })
            }

            >
              {
                () => 
                  <TabNavi
                    navigation={props.navigation}
                    siteURL={props.route.params.siteURL}
                    screenName={item.name} 
                    url={item.url}
                    topNavConfig={item.topNav}
                    topNavStyle={topNavStyle}
                    hideThis={hideThis}
                    bottomBarPages={bottomBarPages}
                    loadingColor={navStyle.activeIconColor}
                    endFlowURLS={endFlowURLS}
                  />
              }
            </Tab.Screen>
          )
        })
      )
    } else {
      return false;
    }
    
  }

  if(buildNavigator() == false){
    let nav = useNavigation();
    nav.navigate("Config Error");
    return <></>;
  }

  return (
    <Tab.Navigator
      screenOptions={({ route }) => ({
        tabBarActiveTintColor: navStyle.activeIconColor,
        tabBarInactiveTintColor: navStyle.defaultIconColor,
        tabBarStyle: {
          backgroundColor: navStyle.backgroundColor,
          paddingBottom: 5,
        }
      })}
    >
      { buildNavigator() }
    </Tab.Navigator>
  );
});

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  buttonNav: {
    flex: 1,
    backgroundColor: 'white',
    height: 50,
    paddingTop: Platform.OS === 'ios' ? 10 : 5,
  },
  viewButton: {
    height: 40,
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
  },
  textNav: {
    marginLeft: 5,
    fontWeight: '400',
    textAlign: 'center',
    fontSize: 12,
    color: '#888888',
  },
  textNavSelected: {
    marginLeft: 10,
    fontWeight: '400',
    textAlign: 'center',
    fontSize: 12,
    color: '#11be52',
  },
  viewButtonBorder: {},
});

export default TabNavigator;
